import React from 'react';
import { DialogContent, DialogContentText, Typography } from '@mui/material';
import ModalCustom from 'components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { closeDialogAction, openDialogAction } from 'store/actions/dialogsActions';
import { useAppState } from 'store/Provider';
import DeliverableEdit from '../ChangeBaselinePages/NewBaseline/EditTotalWorkunit/DeliverableEdit/DeliverableEdit';
import DeliverableMultipleEdit from '../ChangeBaselinePages/NewBaseline/EditTotalWorkunit/DeliverableEdit/DeliverableMultipleEdit';
import { useSelector } from 'store/hooks';

const BaselineEditWorkunit = () => {
  const { state, dispatch } = useAppState();
  const { dialogs } = state;
  const isOpen = dialogs.changeBaselineeditworkunitDialog;
  const { totalworkunitData } = useSelector((state) => state.changeBaseline);
  const { data, type } = dialogs?.data;
  const [t] = useTranslation();

  const modifyData = totalworkunitData?.find((item) => item.id === data);

  const dialogBody = (
    <DialogContent>
      {type === 'single' ? (
        <DeliverableEdit deliverables={[modifyData as any]} />
      ) : (
        <DeliverableMultipleEdit ids={data} />
      )}
    </DialogContent>
  );

  const confirmFn = async () => {
    // console.log(dialogs?.data);

    dispatch(
      openDialogAction({
        name: 'BaselineEditWorkunitCancel',
        data: { data: dialogs?.data?.data, type: dialogs?.data?.type, fromPopup: true },
      })
    );
    // dispatch(closeDialogAction('changeBaselineeditworkunitDialog'));
  };
  const actions = <></>;
  return (
    <ModalCustom
      open={isOpen}
      modalName="changeBaselineeditworkunitDialog"
      onClose={() => confirmFn()}
      onCloseEvent={confirmFn}
      titleText="Edit Deliverables"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: document.documentElement.clientWidth - 400, // Set your width here
          },
        },
      }}
      actions={actions}
      body={dialogBody}
      size="lg"
      confirmLoad
    />
  );
};

export default BaselineEditWorkunit;
